import * as PrimitiveRadixDialog from '@radix-ui/react-dialog';
import { ForwardedRef } from 'react';

export interface SheetTriggerProps extends PrimitiveRadixDialog.DialogTriggerProps {}

export function SheetTrigger(props: SheetTriggerProps, ref: ForwardedRef<HTMLButtonElement>): JSX.Element {
	return <PrimitiveRadixDialog.Trigger {...props} ref={ref} />;
}
